// extracted by css-extract-rspack-plugin
export default {"dropIndicator":"DropIndicator_dropIndicator__plBFc"};